import Web3 from 'web3';

export const web3Default = {
  //Hmy Testnet shard 0
  80: {
    web3Default: new Web3(new Web3.providers.HttpProvider('https://rpc.dusty.plasmnet.io:8545')),
    name: 'Plasm',
    explorer: null,
  },
};

export const networkDefault = 80;

export const getWeb3List = (_chainId) => {
  return web3Default[_chainId];
};
